import { Theme } from "@emotion/react";
import { SxProps, Typography } from "@mui/material";
import React, { ReactNode } from "react";

interface LabelProps {
    htmlFor: string;
    sx?: SxProps<Theme>;
    children?: ReactNode;
}

const LabelComponent = (props: LabelProps) => {
    return <Typography
        component="label"
        htmlFor={props.htmlFor}
        sx={props.sx}
    >
        {props.children}
    </Typography>
}

export default LabelComponent;